import { SignIn, SignUp, useAuth, useClerk } from '@clerk/clerk-react';
import { Center, TFLoadingOverlay } from '@tf/ui';
import type React from 'react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const AcceptInvitationRoute: React.FC = () => {
	const [params] = useSearchParams();
	const clerkStatus = params.get('__clerk_status');

	const { signOut } = useClerk();
	const { isSignedIn } = useAuth();

	useEffect(() => {
		const logout = async () => {
			if (isSignedIn) {
				await signOut({ redirectUrl: window.location.href });
			}
		};
		logout();
	}, [isSignedIn, signOut]);

	if (isSignedIn) {
		return <TFLoadingOverlay />;
	}

	if (clerkStatus === 'sign_up') {
		return (
			<Center mt="20vh">
				<SignUp routing="path" path="/accept-invite" signInForceRedirectUrl={window.location.origin} />
			</Center>
		);
	}

	return (
		<Center mt="20vh">
			<SignIn routing="path" path="/accept-invite" forceRedirectUrl="/" />
		</Center>
	);
};
